// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zg-stoc[data-v-7f968983]{display:none}@media(min-width: 62em){.zg-stoc[data-v-7f968983]{display:-webkit-box;display:flex;position:fixed;top:3.5rem;z-index:10}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
